import { FETCH_REPORT_RES } from '../actions/types';

export default function (state = [], action) {
  switch (action.type) {
    case FETCH_REPORT_RES: {
      const orderType = action.orderType || 'completed';
      if (orderType === 'delivered') {
        return action.payload.filter((order) => order['delivered_at']);
      }
      return action.payload.filter((order) => order['completed_at']);
    }
    default:
      return state;
  }
}
